<template>
  <base-dialog v-model="dialog.show" max-width="500px">
    <template v-slot:title>
      Yêu cầu {{ $t('sidebar.key.name') }}
    </template>
    <base-form ref="form" @submit.stop="onSubmit">
      <v-row>
        <v-col cols="12" class="py-0">
          <field-group
            v-model="dialog.form.name"
            autofocus
            :error-messages="dialog.errors.name"
            label="Tên hiển thị"
            required
            filled
            dense
            @focus="dialog.errors.name = ''"
          ></field-group>
        </v-col>
        <v-col cols="12" class="py-0">
          <field-group
            v-if="!isCreateDialog"
            v-model="dialog.form.key"
            autofocus
            label="Khóa"
            readonly
            filled
            dense
          ></field-group>
        </v-col>
        <v-col cols="12" class="py-0">
          <field-group
            v-model="dialog.form.workspace_ids"
            v-if="workspace.items.length > 1"
            dense
            :error-messages="dialog.errors.workspace_ids"
            filled
            required
            item-text="name"
            item-value="id"
            :items="workspace.items"
            multiple
            :label="$t('sidebar.workspace.name')"
            :loading="workspace.loading"
            chips
            small-chips
            type-input="v-autocomplete"
          >
          </field-group>
          <field-group
            :value="this.workspace.items[0].name"
            v-else
            filled
            :label="$t('sidebar.workspace.name')"
            required
            disabled
            dense
            type-input="v-text-field"
          >
          </field-group>
        </v-col>
        <v-col cols="12" class="py-0">
          <field-group
            v-if="!isCreateDialog"
            v-model="dialog.form.status"
            :items="statuses"
            item-text="name"
            item-value="value"
            filled
            label="Trạng thái"
            type-input="v-select"
          ></field-group>
        </v-col>
        <v-col cols="12" class="py-0">
          <field-group
            v-model="dialog.form.meta.enabled_wms"
            autofocus
            inset
            label="Cho phép sử dụng WMS"
            type-input="v-switch"
          ></field-group>
        </v-col>
        <v-col cols="12" class="py-0">
          <field-group
            v-model="dialog.form.meta.enabled_wfs"
            autofocus
            inset
            label="Cho phép sử dụng WFS"
            type-input="v-switch"
          ></field-group>
        </v-col>
      </v-row>
    </base-form>
    <template v-slot:extra-btn>
      <base-button color="primary" :loading="dialog.loading" @click="onSubmit">
        Yêu cầu
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import { API_KEY } from '@api'
import { copyByJson } from '@utils'
import { EDIT_TYPE } from '@/src/constant'
export default {
  components: {},
  props: {
    workspace: { type: Object, required: true },
  },
  data: () => ({
    types: ['vector', 'raster'],
    dialog: {
      show: false,
      form: { meta: {} },
      errors: {},
      title: '',
      type: '',
      loading: false,
    },
    statuses: [
      {
        name: 'Vô hiệu',
        value: 0
      },
      {
        name: 'Chờ phê duyệt',
        value: 1
      },
      {
        name: 'Đã phê duyệt',
        value: 2
      }
    ]
  }),
  computed: {
    isCreateDialog() {
      return this.dialog.type == EDIT_TYPE.CREATE
    },
  },
  methods: {
    open(item, type = EDIT_TYPE.CREATE) {
      this.dialog.show = true
      this.dialog.form = Object.assign(
        { meta: { enabled_wms: true, enabled_wfs: true } },
        copyByJson(item)
      )
      this.dialog.title = this.$t('actions.' + type)
      this.dialog.type = type
      this.dialog.errors = {}
      this.dialog.loading = false
    },
    onDialogClose() {
      this.dialog = {
        show: false,
        loading: false,
        form: { meta: {} },
        type: EDIT_TYPE.CREATE,
        errors: {},
      }
    },
    async onSubmit() {
      if(this.workspace.items.length == 1){
        this.dialog.form.workspace_ids = [this.workspace.items[0].id]
      }
      if (!(await this.$refs['form'].validate())) {
        return false
      }
      try {
        let data = Object.assign({ meta: {} }, this.dialog.form)
        this.dialog.loading = true
        let res = this.isCreateDialog
          ? await API_KEY.create(data)
          : await API_KEY.update(data.id, data)

        if (res && !res.error) {
          this.onDialogClose()
          this.getData()
        }
        if (
          res &&
          res.error &&
          res.error.response &&
          res.error.response.status == 422
        ) {
          const { response } = res.error
          this.dialog.errors = response.data.errors
        }
      } finally {
        this.dialog.loading = false
      }
    },
    getData() {
      this.$emit('reset')
    },
  },
}
</script>

<style scoped></style>
